module.exports = __webpack_public_path__ + "static/fairy-race-a77f6b14aedfdf8788b21cba22e1cbf2.jpg";